<template>
  <div class="pay-record">
      <!-- 列表 -->
       <van-list
            v-model="loading"
            :finished="finished"
            finished-text=""
            :immediate-check="false"
            @load="onLoad"
          >
        <div class="content" v-if="data.length > 0">
            <div class="item" v-for="(item,index) in data" :key="index">
                <div class="header">
                    <!-- <img :src="item.imgSrc"/> -->
                    <!-- <div class="center"> -->
                        <div class="name">{{item.petrolstationName}}-{{item.oilNo}}</div>
                        <!-- <div class="adress">{{item.address}}</div> -->
                    <!-- </div>                 -->
                    <div class="right">
                        <div class="sign">￥</div>
                        <div class="price">{{item.payPrice}}</div>
                    </div>
                </div>
                <div class="table">
                    <!-- <div class="table-header">
                        <div class="title1">
                            <div>油号</div>
                            <div>枪号</div>
                            <div>单价</div>
                        </div>
                        <div class="title2">
                            <div>#92</div>
                            <div>1号枪</div>
                            <div>￥5.78L</div>
                        </div>
                    </div> -->
                    <div class="table-content">
                        <div class="label">订单金额：</div>
                        <div class="value">￥{{item.amount}}元</div>
                    </div>
                    <div class="table-content">
                        <div class="label">数量：</div>
                        <div class="value">{{item.litre}}L</div>
                    </div>
                    <div class="table-content">
                        <div class="label">订单编号：</div>
                        <div class="value">{{item.orderNo}}</div>
                    </div>
                    <div class="table-content">
                        <div class="label">支付时间：</div>
                        <div class="value">{{item.piadTime}}</div>
                    </div>
                    <div class="table-content">
                        <div class="label">支付状态：</div>
                        <div class="value">{{item.payStatusName}}</div>
                    </div>
                </div>
            </div>
        </div>
         <template v-if="!loading && !data.length">
           <van-empty
             class="custom-image"
             :image="emptyImgUrl"
             description="暂无数据"
           />
         </template>
       </van-list>
       <!-- 回到首页悬浮标 -->
      <div class="pay-record" @click="goHome">
          <img src="@/assets/img/car-life/home.jpg"/>
      </div>
      
  </div>
</template>

<script>
import pic_default from "@/assets/img/car-life/pic_default.png";

import { getPayRecordList } from "@/common/api.js";
import { getUrlParam } from '@/utils/getUrlParam.js'

export default {
    data(){
        return{
            data: [],
            emptyImgUrl: pic_default,
            loading: false,
            finished: false,
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
        }
    },

    computed:{
        params(){
            return{
                productCode: this.productCode,
                contactPhone: this.phone,
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize
            }

        }
    },
    mounted(){
        this.phone = getUrlParam('phone')
        this.productCode = getUrlParam('productCode').replace(/[^\w]/g,'') // 去除\"
        this.getList()
    },

    methods:{
      onLoad(){
        this.pagination.pageNum++;
        console.log('加载中……',this.pagination.pageNum)
        this.getList()
      },
      async getList(){
        this.loading = true;
        const res = await getPayRecordList(this.params)
        if (!res) {
          this.$router.push({path: "/"});
          return;
        }
        if (res.list) {
          this.data = [...this.data, ...res.list];
          if (res.isLastPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
        this.loading = false;
      },
      goHome(){
        this.$router.push({
            path: "/carLife",
            query: {
              phone: this.phone,
            },
          });
      }
    }
}
</script>
<style>
.van-empty {
  padding: 0;
  margin-top: 1.83rem;
}

.custom-image .van-empty__image {
  width: 3.88rem;
  height: 2.44rem;
}
</style>

<style lang="scss" scoped>
 .pay-record{
    height: 100vh;
    padding-top: 12px;
    background: #F4F6F7;
    .content{
        .item{
            margin-top: 12px;
            background: #FFFFFF;
            box-shadow: inset 0px -2px 0px 0px rgba(230,230,230,1);
            .header{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 12px 20px;
                border-bottom: 1px solid #E6E6E6;
                img{
                    width: 36px;
                    height: 36px;
                    margin-right: 8px;
                }
                // .center{
                    .name{
                        // margin-bottom:10px;
                        font-size: .32rem;
                        color: #383838;
                        letter-spacing: 0.48px;
                        font-weight: 500;
                    }
                    .adress{
                        width: 240px;
                        font-size: .24rem;
                        color: #787878;
                        letter-spacing: 0.36px;
                        font-weight: 400;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                // }
                .right{
                    display: flex;
                    color: #383838;
                    line-height: 40px;
                    .sign{
                        font-size: .24rem;
                    }
                    .price{
                        font-size: .48rem;
                    }
                }
            }
            .table{
                padding: 12px 0;
                .table-header{
                    margin: 12px 20px;
                    padding: 5px 15px;
                    background: #F2F5F7;
                    border-radius: 8px;
                    .title1{
                        margin-bottom: 4px;
                        display: flex;
                        font-size: .2rem;
                        color: #787878;
                        div{
                            width: 33.3%
                        }
                    }
                    .title2{
                        display: flex;
                        font-size: .32rem;
                        color: #383838;
                        div{
                            width: 33.3%
                        }
                    }
                }
                .table-content{
                    display: flex;
                    padding-bottom: 12px;
                    padding-left: 20px;
                    .label{
                        width: 90px;
                        font-size: .32rem;
                        color: #787878;
                        letter-spacing: 0.48px;
                        font-weight: 400;
                    }
                    .value{
                        font-size: .32rem;
                        color: #383838;
                        letter-spacing: 0.48px;
                        font-weight: 400;
                    }
                }
               
            }
        }
        .item:first-child{
            margin-top: 0;
        }
    }
    .no-data-text{
        font-size: .32rem;
        color: #C8C8C8;
        letter-spacing: 0.48px;
        text-align: center;
        font-weight: 400;
    }
    .pay-record{
        padding: 0 0;
        position: fixed;
        right: 12px;
        bottom: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 42px;
        height: 42px;
        background: rgba(255,255,255,0.84);
        border-radius: 50%;
        box-shadow: 0px 0px 16px 0px rgba(51,153,255,0.3);
        img{
            width: 24px;
            height: 24px;
        }
    }
}

</style>
